import { render, staticRenderFns } from "./BookingPayments.vue?vue&type=template&id=805a4c5c&scoped=true"
import script from "./BookingPayments.vue?vue&type=script&lang=js"
export * from "./BookingPayments.vue?vue&type=script&lang=js"
import style0 from "./BookingPayments.vue?vue&type=style&index=0&id=805a4c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805a4c5c",
  null
  
)

export default component.exports